import React from 'react';
import Dialog, { DialogProps } from '../../../components/dialog/Dialog';
import { LoadingButton } from '@mui/lab';
import { Button } from '@mui/material';
import { useSiteDeleteDesignMutation } from '../../../generated/types';
import { enqueueSnackbar } from 'notistack';
import i18next from 'i18next';

interface DeleteSiteModalProps extends Omit<DialogProps, 'onClose'> {
    onClose: () => void;
    onSuccess?: () => void;
}
const DeleteSiteModal: React.FC<DeleteSiteModalProps> = ({ onClose, onSuccess, ...props }) => {
    const [deleteSite, { loading }] = useSiteDeleteDesignMutation();

    const handleDeleteDesign = () => {
        deleteSite({
            onCompleted() {
                onSuccess && onSuccess();
                onClose();
            },
            onError(e) {
                console.log(e);
                enqueueSnackbar(i18next.t('site:message.delete.failed'), { variant: 'error' });
            },
        });
    };

    return (
        <Dialog {...props} onClose={onClose}>
            <div className="w-full pt-20 px-30 pb-40">
                <p className="text-14 leading-17">
                    Are you sure you want to delete your site? Once deleted, it cannot be recovered.
                </p>
                <div className="flex items-center mt-30 space-x-10">
                    <Button size={`large`} color={`primary`} variant="outlined" fullWidth={true} onClick={onClose}>
                        Cancel
                    </Button>

                    <LoadingButton
                        loading={loading}
                        size={`large`}
                        color={`primary`}
                        variant={'contained'}
                        fullWidth={true}
                        onClick={() => handleDeleteDesign()}
                    >
                        Delete
                    </LoadingButton>
                </div>
            </div>
        </Dialog>
    );
};

export default DeleteSiteModal;
